import { type ReactNode } from 'react';
import { Link, Text } from '@launchpad-ui/components';

import styles from './Installation.module.css';

export const AndroidInstallation = (): ReactNode => {
  return (
    <Text className={styles.descriptionText}>
      The SDK uses{' '}
      <Link href="https://developer.android.com/jetpack/androidx" target="_blank" rel="noopener noreferrer">
        AndroidX from Jetpack
      </Link>
      . If your project does not use AndroidX, read{' '}
      <Link href="https://developer.android.com/jetpack/androidx/migrate" target="_blank" rel="noopener noreferrer">
        Android's migration guide
      </Link>
      .
    </Text>
  );
};
